import { z } from "zod";
export const ZAssetTarget = z.union([
    z.literal("release-notes"),
    z.literal("project-attachments"),
    z.literal("media-assets"),
]);
export const ASSET_TARGETS = {
    "release-notes": {
        containerName: "release-assets",
        ttlMinutes: 30,
        permissions: "r",
        allowedPrefix: "deploy-notes/",
    },
    "project-attachments": {
        containerName: "project-attachments",
        ttlMinutes: 60,
        permissions: "r",
        allowedPrefix: "projects/",
    },
    // ✅ NEW
    "media-assets": {
        containerName: "media-assets",
        ttlMinutes: 60,
        permissions: "r",
        allowedPrefix: "assets/",
    },
};
